var $ = (typeof window !== "undefined" ? window['$'] : typeof global !== "undefined" ? global['$'] : null);

$(document).ready(function() {
    $(document).foundation();
});
